const PIXELS_PER_REM = 16;

/**
 * @name getGutterWidth
 *
 * @description Returns the current gutter width in pixels, depending on the current viewport, as a number
 *
 * @example
 * import { getGutterWidth } from '@workbench/core';
 *
 * getGutterWidth(); // 16
 */
export function getGutterWidth(): number {
  const gutterWithRemUnit = getComputedStyle(document.documentElement).getPropertyValue('--wb-grid-gutter-width');
  const gutterInPixels = Number(gutterWithRemUnit.replace('rem', '')) * PIXELS_PER_REM;
  return gutterInPixels;
}
